export const beerVarieties = [
  "lager",
  "pale",
  "ipa",
  "west coast",
  "neipa",
  "session",
  "table",
  "sour",
  "stout",
  "porter",
  "fruited",
  "mixed fermentation",
  "german",
  "belgian",
  "weissbier",
  "berlinerweisse",
  "hefeweizen",
  "radler",
  "bitter",
  "mild",
];

export const spiritVarieties = [
  "spirit",
  "gin",
  "vodka",
  "rum",
  "rtd",
  "cocktails",
];

export const softVarieties = ["soda", "juice", "kombucha"];

export const wineVarieties = ["red", "white", "rosé", "sparkling"];

export type ProductStyle =
  | "beer"
  | "cider"
  | "spirits"
  | "softDrinks"
  | "wine"
  | "mead";

const styleSearchStrings = {
  beer: ["beer", ...beerVarieties].join("|"),
  cider: "cider",
  spirits: spiritVarieties.join("|"),
  softDrinks: softVarieties.join("|"),
  wine: "wine",
  mead: "mead",
};

export const getProductStyleSearchString = (style: ProductStyle) => {
  console.log({ style: style });
  return styleSearchStrings[style];
};
